import { createFileRoute, Link } from '@tanstack/react-router';
import { JournalEntryForm } from '../../components/journal/JournalEntryForm';
import { useJournalEntry } from '../../hooks/useJournalEntries';
import { useActiveCompanyId } from '../../stores/useCompanyStore';

export const Route = createFileRoute('/_auth/journal/new')({
  validateSearch: (search: Record<string, unknown>): { copyFrom?: string } => ({
    copyFrom: typeof search.copyFrom === 'string' ? search.copyFrom : undefined,
  }),
  component: NewJournalEntryPage,
});

function NewJournalEntryPage() {
  const companyId = useActiveCompanyId();
  const { copyFrom } = Route.useSearch();
  const { data: source, isLoading } = useJournalEntry(companyId, copyFrom ?? '');

  if (!companyId) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: 32 }}>
        <h1 style={{ marginTop: 0 }}>New journal entry</h1>
        <p className="muted">No active company.</p>
        <Link to="/companies" className="btn-primary" style={{ display: 'inline-block', textDecoration: 'none' }}>
          Go to Companies
        </Link>
      </div>
    );
  }

  // When copying, wait for the source entry so the form can seed its initial state.
  if (copyFrom && isLoading) return <p className="muted">Loading…</p>;

  return (
    <div>
      <h1 style={{ fontSize: 24, marginTop: 0 }}>
        {copyFrom ? 'Copy journal entry' : 'New journal entry'}
      </h1>
      {copyFrom && (
        <p className="muted" style={{ marginTop: 0, fontSize: 13 }}>
          Duplicated from {source?.entryNumber ?? 'an entry'}. A new entry number is assigned on save.
        </p>
      )}
      <JournalEntryForm
        companyId={companyId}
        key={copyFrom ?? 'new'}
        initialEntry={copyFrom ? source : undefined}
      />
    </div>
  );
}
